<template>
    <el-dialog :class="[currentTheme]"  :title="dialogName" :visible.sync="dialogVisible" width="800px" :close-on-click-modal="false"  :append-to-body='true'>
      <div class="main-box">
        <xr-table ref="xrTable" :configure="configure"></xr-table>
      </div>

      <pay-info ref="payInfo" v-if="isPayInfoShow"></pay-info>

    </el-dialog>

</template>

<script>

  import PayInfo from './Pay-Info'

    export default {
      name: "CompanyInfo",
      data() {
        return {
          dialogName: '购买列表',
          dialogVisible: false,                                        //弹框
          isPayInfoShow: false,                                        //弹框
          temp: {
            themeType :'',
          },
          configure: {
            url: '/web/service?method=tBusinessBaseComboInfo_list',
            listParam: {
              comboName: ''
            },
            id: 'combo-info-table',
            idField: 'id',
            that: this,
            tableHeight: 400,
            isShowSearch: false,
            columns: [
              {
                field: 'sn',
                width: 60,
              },
              {
                field: 'comboName',
                title: '权益名称',
                align: 'center',
                width: 120,
                sortable: true,
                condition: {
                  searchType: 'input',
                  searchName: 'comboNameSearch',
                  value: ''
                },
              },
              {
                field: 'comboMoney',
                title: '权益价格（元）',
                align: 'center',
                width: 130,
                sortable: true,
                condition: {
                  searchType: 'input',
                  searchName: 'comboMoneySearch',
                  value: ''
                },
              },
              {
                field: 'remark',
                title: '权益说明',
                sortable: true,
                condition: {
                  searchType: 'input',
                  searchName: 'supplierNameSearch',
                  value: ''
                },
              },
              {
                field: 'operate',
                title: '操作',
                cellType: 'operate',
                align: 'center',
                width: 120,
                that: this,
                operateList: [
                  {
                    text: '购买',
                    iconCls: 'wk wk-edit',
                    that: this,
                    handler: function (row) {
                      this.that.handlePayOpenDialog(row);
                    }
                  }
                ]
              }
            ],
            toolbar: [

            ]
          }
        }
      },
      computed: {
        orgCategory() {
          return this.$store.getters.orgCategory; //获取机构类型
        },
        orgId() {
          return this.$store.getters.orgId; //获取机构id
        },
        orgName() {
          return this.$store.getters.orgName; //获取机构名称
        },
        currentTheme() {
          return this.$store.getters.themeType; //获取当前的主题类型
        },
      },
      components: {
        PayInfo
      },
      methods: {
        init(){
          this.dialogVisible = true;
          this.$nextTick(()=>{
            this.$refs.xrTable.getData();
          })
        },
        buy(){

        },
        //打开【修改】的页面
        handlePayOpenDialog(row){
          this.isPayInfoShow = true;
          this.$nextTick(()=>{
            this.$refs.payInfo.init(row.comboMoney) //初始化页面
          })
        },
      }
    }
</script>

<style scoped>
  .about-title{position: relative;}
  .about-title .about-font{
    position: absolute;
    color: #fff;
    top: 33%;
    left: 26%;
    font-size: 33px;
    font-weight: 600;
  }
  .about-title img{width: 100%;}
</style>



// WEBPACK FOOTER //
// src/components/header/Combo-Buy.vue